module.exports = __webpack_public_path__ + "static/img/victim-teens.2e95c9a2.png";